import { render } from "./MenuAdminOverview.vue?vue&type=template&id=642178e4&scoped=true"
import script from "./MenuAdminOverview.vue?vue&type=script&lang=js"
export * from "./MenuAdminOverview.vue?vue&type=script&lang=js"

import "./MenuAdminOverview.vue?vue&type=style&index=0&id=642178e4&scoped=true&lang=css"

import exportComponent from "/home/kitrin/builds/isoevolve/20261004-205117/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-642178e4"]])

export default __exports__